export default "__VITE_ASSET__DMrTtOhO__"